import { jsx as _jsx } from "react/jsx-runtime";
import { Volume2, VolumeX } from 'lucide-react';
import { useAudioSettings } from '@/lib/audio';
import { cn } from '@/lib/utils';
/**
 * Toggle audio on/off dans le header. Persiste via localStorage (cf
 * src/lib/audio.ts). Mute global Howler immédiatement.
 *
 * NB : pas de slider de volume pour l'instant — toggle binaire suffit
 * pour V1. Slider à ajouter en /settings plus tard si besoin.
 */
export function AudioToggle() {
    const { enabled, setEnabled } = useAudioSettings();
    return (_jsx("button", { type: "button", "aria-label": enabled ? 'Couper le son' : 'Activer le son', title: enabled ? 'Couper le son' : 'Activer le son', onClick: () => setEnabled(!enabled), className: cn('grid h-10 w-10 place-items-center rounded-xl transition-colors', enabled
            ? 'text-ink-300 hover:bg-ink-900/60 hover:text-ink-100'
            : 'text-ink-500 hover:bg-ink-900/60 hover:text-ink-300'), children: enabled ? _jsx(Volume2, { className: "h-4 w-4" }) : _jsx(VolumeX, { className: "h-4 w-4" }) }));
}
